/**
 * «Кто что сделал последним» по задаче (Kostya, round 2). The server hands it
 * back with the task itself (`last_action`, PR #19): the newest of the task's
 * events and its discussion's messages, notices by «Система» left out. The task
 * read is live already, so the line follows the work without reads of its own.
 */

import type { ActivityOut, TaskLastAction } from "@/api/types";
import { whoDid, type LastAction } from "@/kit";
import { activityLabel } from "@/lib/activity";

export function lastActionOf(action: TaskLastAction | null | undefined): LastAction | null {
  if (!action) return null;
  const what = action.source === "chat"
    ? action.type === "chat.file" ? "приложил файл" : "написал в обсуждение"
    : activityLabel({ type: action.type, entity_type: "task" } as ActivityOut);
  return { who: whoDid(action.actor_name, action.via_agent), what, at: action.at };
}
